import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import generalActions from 'redux/actions/generalActions'
import pollActions from 'redux/actions/pollActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import containerSelector from 'redux/selectors/poll/creation_tool_timer_modal_selector'

import TimerModal from 'views/modals/timer_modal'

class PollTimerModalContainer extends PureComponent {

	constructor() {
		super()
		this.closeModalHandler = this.closeModalHandler.bind(this)
	}

	closeModalHandler() {
		this.props.actions.closeModal(this.props.modalName)
	}

	render() {
		return (
			<TimerModal
				max={5999}
				min={0}
				step={15}
				value={this.props.value}
				saveHandler={this.props.actions.save}
				cancelHandler={this.props.actions.cancel}
				closeModalHandler={this.closeModalHandler}
			/>
		)
	}

}

function mapStateToProps(state) {
	return containerSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
		save: pollActions.saveTimer,
		cancel: pollActions.cancelTimer,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PollTimerModalContainer)
